<div class="armor-wrap">
  <div class="armor">
    <div class="label">Armor</div>
    <div class="value">{{ armorClass }}</div>
  </div>
  <div class="initiative">
    <div class="label">Initiative</div>
    <div class="value">{{ initiave }}</div>
  </div>
  <div class="movement">
    <div class="label">Movement speed</div>
    <div class="value">{{ movement }}</div>
  </div>
</div>
